<template>
  <div class="page">
    <div class="header">
      <h2>表单管理</h2>
      <button class="btn primary" @click="openCreate">新建表单</button>
    </div>
    <table v-if="forms.length" class="table">
      <thead>
        <tr>
          <th>标题</th>
          <th>Code</th>
          <th>状态</th>
          <th>截止时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="f in forms" :key="f.id">
          <td>{{ f.title }}</td>
          <td><code>{{ f.code }}</code></td>
          <td>{{ statusLabel(f.status) }}</td>
          <td>{{ formatTime(f.endAt) }}</td>
          <td class="actions">
            <router-link :to="`/dashboard/forms/${f.id}/edit`">{{ f.submissionCount > 0 ? '查看' : '编辑' }}</router-link>
            <router-link :to="`/dashboard/forms/${f.id}/submissions`">提交记录</router-link>
            <button type="button" class="link" @click="copyLink(f.code)">复制链接</button>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else class="empty">暂无表单</p>

    <div v-if="showCreate" class="modal">
      <div class="modal-body">
        <h3>新建表单</h3>
        <label>Code<input v-model="draft.code" /></label>
        <label>标题<input v-model="draft.title" /></label>
        <label>状态
          <select v-model="draft.status">
            <option value="DRAFT">草稿</option>
            <option value="PUBLISHED">已发布</option>
            <option value="CLOSED">已关闭</option>
          </select>
        </label>
        <label>每人最多提交次数<input v-model.number="draft.maxSubmissionsPerUser" type="number" min="1" max="3" /></label>
        <div class="modal-actions">
          <button @click="showCreate = false">取消</button>
          <button class="primary" @click="create">创建</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formService } from '@/services/formService'

export default {
  name: 'FormManagement',
  data() {
    return {
      forms: [],
      showCreate: false,
      draft: {
        code: '',
        title: '',
        status: 'DRAFT',
        maxSubmissionsPerUser: 3
      }
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    statusLabel(status) {
      return { DRAFT: '草稿', PUBLISHED: '已发布', CLOSED: '已关闭' }[status] || status
    },
    formatTime(v) {
      if (!v) return '-'
      return String(v).replace('T', ' ').slice(0, 16)
    },
    async load() {
      const res = await formService.listForms()
      if (res.success) this.forms = res.data || []
    },
    openCreate() {
      this.showCreate = true
    },
    async create() {
      const res = await formService.createForm({ ...this.draft })
      if (res.success) {
        this.showCreate = false
        await this.load()
        this.$router.push(`/dashboard/forms/${res.data.id}/edit`)
      } else {
        alert(res.error || '创建失败')
      }
    },
    copyLink(code) {
      const url = formService.shareUrl(code)
      navigator.clipboard.writeText(url).then(() => alert('已复制：' + url))
    }
  }
}
</script>

<style scoped>
.page { padding: 24px; }
.header { display: flex; justify-content: space-between; align-items: center; }
.table { width: 100%; border-collapse: collapse; margin-top: 16px; }
.table th, .table td { border-bottom: 1px solid #eee; padding: 10px; text-align: left; }
.actions { display: flex; gap: 12px; }
.btn.primary, button.primary { background: #409eff; color: #fff; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; }
.link { background: none; border: none; color: #409eff; cursor: pointer; }
.modal { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; }
.modal-body { background: #fff; padding: 20px; border-radius: 8px; width: 360px; display: flex; flex-direction: column; gap: 10px; }
.modal-body label { display: flex; flex-direction: column; gap: 4px; font-size: 13px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 8px; }
.empty { color: #999; }
</style>
